import { useBucket } from '@mc/experiments-react'

// Growthbook feature flag: https://app.growthbook.io/features/jar-690_v1_social_logins_google
export const SOCIAL_LOGINS_GOOGLE_FLAG = 'jar-690_v1_social_logins_google'

export const useIsSocialLoginsGoogleEnabled = () => {
  const bucket = useBucket(SOCIAL_LOGINS_GOOGLE_FLAG)
  // Returns true if bucket is truthy (not null/undefined/control)
  return !!bucket && bucket !== 'control'
}
